/**
 * 判断鼠标是否在元素内
 * @param event mouse event
 * @param target 目标dom元素
 * @returns
 */
export function isMouseLeave(event: MouseEvent, target: HTMLElement) {
  const rect = target.getBoundingClientRect();

  // 鼠标位置
  const x = event.clientX;
  const y = event.clientY;

  // 卡片位置
  const left = rect.left;
  const right = rect.right;
  const top = rect.top;
  const bottom = rect.bottom;

  // 判断鼠标是否在卡片内，+1-1是为了解决缓慢移出边界时会有误差情况
  return x <= left + 1 || x >= right - 1 || y <= top + 1 || y >= bottom - 1;
}
